//手机验证码相关 api
import request from '@/api/request'
// 获取修改页面数据
export function getCodeApi(phone: string) {
    let url = '/api/phone/code';
    let data = {
        "phone": phone
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}



export function phoneLoginApi(data: any) {
    let url = '/api/login/phone';
    return request({
        url: url,
        method: 'post',
        data
    })
}
